export let postToLabel = "hBY7Wb";
export default {postToLabel};